<template>
  <v-app id="app">
    <toolbar />

    <v-main>
      <v-container
        class="bg-white"
        fluid
      >
        <v-row>
          <v-col cols="12">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <footer-cmp class="app-footer" />
    <app-dialog />
  </v-app>
</template>

<script>
import toolbar from '@/components/Toolbar.vue';
import FooterCmp from '@/components/Footer.vue';
import AppDialog from '@/components/Dialog.vue';

export default {
  components: {
    toolbar,
    'footer-cmp': FooterCmp,
    'app-dialog': AppDialog,
  },
};
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .v-main {
    flex: 1 0 auto;
  }

  .app-footer {
    margin-top: auto;
  }
}

.v-application {
  &.theme--light {
    background-color: #fff!important;
  }

  .v-field,
  .v-field__overlay {
    background-color: transparent !important;
  }

  .v-field__overlay {
    opacity: 0 !important;
  }

  .v-input__slot .theme--light.v-label {
    color: rgba(0,0,0,.65);
    font-size: .95rem;
  }

  .efx-sheet {
    .v-input__slot .theme--light.v-label {
      color: rgba(0,0,0,.75);
    }
  }

  .display-1{
    font-size: 27px;
  }

  .v-btn.v-btn--contained.v-btn--router {
    color: #fff!important;
  }
}
</style>
